import { alpha, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type VisitorVisitTypeRadioCardsProps = {
  index: number;
  isBookPlace: boolean;
  onBookPlaceChange: (bookPlace: boolean) => void;
};

const visitTypeCardSx =
  (selected: boolean) => (theme: { palette: { primary: { main: string } } }) => ({
    alignItems: "center",
    border: `1px solid ${selected ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.2)}`,
    borderRadius: 1.5,
    flex: 1,
    m: 0,
    mx: 0,
    px: 1.25,
    py: 1,
    bgcolor: selected ? alpha(theme.palette.primary.main, 0.06) : "transparent"
  });

export function VisitorVisitTypeRadioCards({
  index,
  isBookPlace,
  onBookPlaceChange
}: Readonly<VisitorVisitTypeRadioCardsProps>) {
  const { t } = useTranslation();
  const visitKind = isBookPlace ? "bookPlace" : "visitOnly";

  return (
    <RadioGroup
      row
      aria-label={t("_visitorBooking_visitTypeLabel")}
      data-testid={`visitor-booking-kind-switch-${index}`}
      sx={{ flexWrap: { xs: "wrap", sm: "nowrap" }, gap: 1, width: "100%" }}
      value={visitKind}
      onChange={e => onBookPlaceChange(e.target.value === "bookPlace")}
    >
      <FormControlLabel
        control={<Radio size="small" />}
        data-testid={`visitor-booking-kind-visit-only-${index}`}
        label={<Typography variant="body2">{t("_visitorBooking_visitType_visitOnly")}</Typography>}
        sx={visitTypeCardSx(visitKind === "visitOnly")}
        value="visitOnly"
      />
      <FormControlLabel
        control={<Radio size="small" />}
        data-testid={`visitor-booking-kind-book-place-${index}`}
        label={<Typography variant="body2">{t("_visitorBooking_visitType_bookPlace")}</Typography>}
        sx={visitTypeCardSx(visitKind === "bookPlace")}
        value="bookPlace"
      />
    </RadioGroup>
  );
}
